import { getAuthUrl } from "./config-utils";

export type LegalDocument = "terms" | "privacy";

/**
 * The terms of use and the privacy policy are published by the login app
 * (`/terms`, `/privacy`), the pages its consent checkbox links to: link there
 * in the interface language instead of keeping a second copy of the text.
 */
export const legalPageUrl = (
  document: LegalDocument,
  language?: string | null
): string => {
  const url = new URL(`/${document}`, new URL(getAuthUrl()).origin);
  url.searchParams.set("language", language || "fr");
  return url.toString();
};
